import { render, staticRenderFns } from "./FiltersComponent.vue?vue&type=template&id=c4167800"
import script from "./FiltersComponent.vue?vue&type=script&lang=js"
export * from "./FiltersComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports